import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Popover, Overlay } from 'react-bootstrap';
import cn from 'classnames';

import { Button } from 'components/Button';
import style from './styles.scss';

const PopoverCheckbox = ({
  isChecked = false,
  onChange = () => {},
  title = '',
  className = '',
  errorMessage = '',
  isDisabled = false,
  type = 'checkbox',
  label = [],
  name,
  id,
  value = 'on',
  hasScrollCondition = true,
  isButtonDisabled = true,
  children = null,
}) => {
  const [show, setShow] = useState(false);
  const [isButtonDisabledState, setIsButtonDisabledState] = useState(true);
  const [target, setTarget] = useState(null);

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop < e.target.getBoundingClientRect().height + 50;
    if (bottom) {
      setIsButtonDisabledState(false);
    }
  };

  const handleChange = (e) => {
    if (isChecked) {
      onChange(false);
    } else {
      setTarget(e.target);
      setShow(!show);
    }
  };

  const handleAcceptButton = (e) => {
    e.preventDefault();
    if (isDisabled) return false;

    onChange(type === 'checkbox' ? !isChecked : value);
    setShow(false);
  };

  const popoverClick = (childrenData, idData, hasScrollConditionData) => (
    <Popover id={`${idData}-wrapper`} className={style.popover} title={title}>
      <div className={style.scrollBar} onScroll={hasScrollConditionData ? handleScroll : undefined}>
        {childrenData}
      </div>
      <div className="small-12" style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className={cn('button small green', style.button)}
          onClick={handleAcceptButton}
          isDisabled={hasScrollConditionData && isButtonDisabled && isButtonDisabledState}
        >
          I Agree
        </Button>
      </div>
    </Popover>
  );

  return (
    <div className={style.container}>
      <div className={style.checkbox}>
        <Overlay
          show={show}
          target={target}
          placement="top"
          containerPadding={20}
          rootClose
          onHide={() => {}}
        >
          {popoverClick(children, id, hasScrollCondition)}
        </Overlay>
        <label className={cn(className, style.label)} htmlFor={id}>
          <input
            className={style.input}
            type={type}
            name={name}
            onChange={handleChange}
            checked={isChecked}
            id={id}
          />
          {label.map((item, index) => <Fragment key={index}>{item}</Fragment>)}
        </label>
      </div>
      {!!errorMessage && <div className={style.error}>{errorMessage}</div> }
    </div>
  );
};

PopoverCheckbox.propTypes = {
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.array,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  hasScrollCondition: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default PopoverCheckbox;
